import { render, staticRenderFns } from "./OffersForLot.vue?vue&type=template&id=b2832350&scoped=true"
import script from "./OffersForLot.vue?vue&type=script&lang=js"
export * from "./OffersForLot.vue?vue&type=script&lang=js"
import style0 from "./OffersForLot.vue?vue&type=style&index=0&id=b2832350&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2832350",
  null
  
)

export default component.exports